export default "__VITE_ASSET__DI_3vECp__"